// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__v7ClR","addWidgetButton":"Header_addWidgetButton__3FyV3","dashboardTabs":"Header_dashboardTabs__3Dix_","active":"Header_active__3bY7u"};